import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "resend",
  "use": "resend-usage",
  "viewBox": "0 0 42.37 48.62",
  "content": "<symbol viewBox=\"0 0 42.37 48.62\" id=\"resend\"><title>资源 87</title><g id=\"resend_图层_2\" data-name=\"图层 2\"><g id=\"resend_图层_1-2\" data-name=\"图层 1\"><path d=\"M9.08,39.56a1.51,1.51,0,0,0,1.51,1.51H31.78a1.51,1.51,0,1,0,0-3H10.59A1.51,1.51,0,0,0,9.08,39.56Z\" /><path d=\"M29.45,33.14a1.51,1.51,0,1,0,0-3H12.93a1.51,1.51,0,0,0,0,3Z\" /><path d=\"M40.86,21.38a1.51,1.51,0,0,0-1.51,1.51v22.7H3V3.22H22.7a1.51,1.51,0,1,0,0-3H3a3,3,0,0,0-3,3V45.59a3,3,0,0,0,3,3H39.35a3,3,0,0,0,3-3V22.89A1.51,1.51,0,0,0,40.86,21.38Z\" /><path d=\"M17.46,20.15v5a1.32,1.32,0,0,0,.39,1,1.28,1.28,0,0,0,.95.4,1.37,1.37,0,0,0,1.37-1.37v-5a9.72,9.72,0,0,1,9.71-9.71h7.79L33,15.05a1.41,1.41,0,0,0-.67,1.19,1.39,1.39,0,0,0,1.39,1.39,1.44,1.44,0,0,0,.86-.3,1.11,1.11,0,0,0,.23-.23L41.88,10a1.37,1.37,0,0,0,0-1.92L34.14.38a1.39,1.39,0,0,0-1.92,0,1.33,1.33,0,0,0-.39,1,1.32,1.32,0,0,0,.39,1l5.42,5.42H29.83a11.89,11.89,0,0,0-4.8,1,12.41,12.41,0,0,0-7.57,11.44Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/resend.svg
// module id = DbRJ
// module chunks = 264